import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";
import {ConstantsService} from "../../services/constants/constants.service";
import {TranslatorService} from "../../services/translator/translator.service";
import {PermissionsService} from "../../services/permissions/permissions.service";
declare var require: any
var _ = require('lodash');

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.pug',
  styleUrls: ['./phone-input.component.scss'],
  standalone: false
})
export class PhoneInputComponent implements OnInit, OnChanges {

  @Input() phone = '';
  @Input() disable_edit = false;
  @Input() country_code = '';
  @Input() mobile_phone = '';
  @Input() pulse_edit_recipient = false;
  @Input() source = '';
  @Input() hideSelect = true;
  @Input() hasError = false;
  @Output() phoneUpdate = new EventEmitter();
  @Output() touched = new EventEmitter();
  countriesCallingCode = {'all': ConstantsService.COUNTRIES_CALLING_CODE, 'popular': ConstantsService.FREQUENT_COUNTRIES_CALLING_CODE};
  callingCode = '';
  phoneNumber = '';
  countryList: any = {};
  phoneUtil = PhoneNumberUtil.getInstance();
  ent_10313_password_policy_and_mfa = false;

  constructor(private translator: TranslatorService, private permissions: PermissionsService) {
    // @ts-ignore
    this.callingCode = localStorage.getItem('callingCode');
    this.ent_10313_password_policy_and_mfa = this.permissions.isFeatureActivated('ent-10313-password-policy-and-mfa');
  }

  ngOnInit() {
    if (this.source === 'send_request') this.setEditRecipientMobile();
    else this.setCountryCode();
  }

  ngOnChanges() {
    if (this.source === 'send_request') this.setEditRecipientMobile();
    else this.setCountryCode();
  }

  onTouched() {
    this.touched.emit(true);
  }

  setEditRecipientMobile() {
    if ((this.country_code) && (this.mobile_phone)) {
      try {
        let parsedPhone;
        if(this.country_code.startsWith('+')) {
          parsedPhone = this.phoneUtil.parse(this.country_code + this.mobile_phone);
        } else {
          parsedPhone = this.phoneUtil.parse('+' + this.country_code + this.mobile_phone);
        }
        this.callingCode = this.country_code;
        this.phoneNumber = parsedPhone.getNationalNumber();
      } catch (e) {
        this.callingCode = this.country_code;
        this.phoneNumber = this.mobile_phone;
      }
    }
    else {
      if (this.country_code){
        this.callingCode = !this.country_code?.startsWith('+') ? '+' + this.country_code : this.country_code;
      }
      else this.callingCode = this.country_code;
      this.phoneNumber = this.mobile_phone;
      this.setCountryList();
    }
  }

  setCountryCode() {
    if (this.phone) {
      try {
        let parsedPhone;
        if(this.phone.startsWith('+')) {
          parsedPhone = this.phoneUtil.parse(this.phone);
        } else {
          parsedPhone = this.phoneUtil.parse('+' + this.phone);
        }
        this.callingCode = '+' + parsedPhone.getCountryCode();
        this.phoneNumber = parsedPhone.getNationalNumber();
      } catch (e) {
        if(this.phoneNumber === '' && this.callingCode !== this.phone) {
          const phoneWithPlus = this.phone.startsWith('+') ? this.phone : '+' + this.phone;
          const isKnownCallingCode = this.countriesCallingCode.all.some(c => c.phone_code === phoneWithPlus);
          if (isKnownCallingCode) {
            this.callingCode = phoneWithPlus;
            this.phoneNumber = '';
          } else {
            this.callingCode = '';
            this.phoneNumber = this.phone;
          }
        }
      }
    }
    else {
      this.setCountryList();
    }
  }

  setCountryList() {
    this.countryList = this.countriesCallingCode;
    this.setCountryByIP();
  }


  handleUpdate(update) {
    if('phoneCode' in update) {
      this.callingCode = update['phoneCode'];
    }
    try {
      let parsedPhone;
      if(this.callingCode) {
        parsedPhone = this.phoneUtil.parse(this.callingCode + this.phoneNumber);
      } else {
        parsedPhone = this.phoneUtil.parse(this.phoneNumber);
      }
      this.callingCode = '+' + parsedPhone.getCountryCode();
      this.phoneNumber = this.phoneUtil.format(parsedPhone, PhoneNumberFormat.NATIONAL);
      if (this.source === 'send_request') this.phoneUpdate.emit({'country_code': "" + this.callingCode, 'mobile_phone': "" + parsedPhone.getNationalNumber()});
      else this.phoneUpdate.emit({'phone': "" + this.callingCode + parsedPhone.getNationalNumber()});
    } catch (e) {
      if (this.source === 'send_request') this.phoneUpdate.emit({'country_code': "" + this.callingCode, 'mobile_phone': "" + this.phoneNumber});
      else this.phoneUpdate.emit({'phone': "" + this.callingCode + this.phoneNumber});
    }
    localStorage.setItem('callingCode', this.callingCode);
  }

  setCountryByIP() {
    try {
      if (!this.callingCode) {
        if (this.source === 'send_request') {
          if (!this.mobile_phone) this.setIp();
        }
        else this.setIp();
      }
    } catch (error) {
      this.callingCode = '+61';
      console.warn('geo ip library could not be resolved.', error);
    }
  }

  setIp() {
    window['geoip2'].country((res) => {
      let resolvedCountryName = res.country.names.en;
      if (this.translator.getLocale() === 'FR-CA') {
        resolvedCountryName = res.country.names.fr;
      }
      const countryInstance = _.find(this.countryList.all, {label: resolvedCountryName});
      // once ip is resolved, update country and phone if not set.
      this.callingCode = countryInstance.phone_code;
    });
  }
  onPhoneInput(event: Event) {
  const input = event.target as HTMLInputElement;

  const digitsOnly = input.value.replace(/[^0-9]/g, '');

  this.phoneNumber = digitsOnly.slice(0, 15);

  input.value = this.phoneNumber;

  this.emitPhoneUpdate();
}

  emitPhoneUpdate() {
  const normalisedCallingCode = this.callingCode ? (this.callingCode.startsWith('+') ? this.callingCode : `+${this.callingCode}`) : '';
  this.callingCode = normalisedCallingCode;

  const fullPhone = `${normalisedCallingCode}${this.phoneNumber}`;

  if (this.source === 'send_request') {
    this.phoneUpdate.emit({
      country_code: normalisedCallingCode,
      mobile_phone: this.phoneNumber
    });
  } else {
    this.phoneUpdate.emit({ phone: fullPhone });
  }
  localStorage.setItem('callingCode', normalisedCallingCode);
}
onKeyPress(event: KeyboardEvent) {
  if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete') {
    event.preventDefault();
  }
}


}
